<template>
  <i :class="cn(variants({ size }), props.class)" :data-icon="name">
    <inline-svg :src="src" class="w-full h-full" />
  </i>
</template>

<script setup>
import { sizes, variants } from ".";
import { computed } from "vue";
import { cn } from "@/Utils/cn";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

const props = defineProps({
  name: {
    type: String,
    default: "placeholder",
  },
  variant: {
    type: String,
    default: "outline",
  },
  class: { type: null, required: false },
  size: {
    type: String,
    validator: (val) => ["custom", ...sizes].includes(val),
    default: "md",
  },
  mdSize: {
    type: String,
    validator: (val) => sizes.includes(val),
    default: undefined,
  },
});

const src = computed(() => {
  if (!props.name) {
    return "/images/icon/placeholder-" + props.variant + ".svg";
  }

  return "/images/icon/" + props.name + "-" + props.variant + ".svg";
});

const size = computed(() => {
  if (props.mdSize) {
    return maxSmall.value ? props.size : props.mdSize;
  }
  return props.size;
});
</script>
